<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.id" placeholder="请输入NFTID" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择铸造状态" size="small">
                        <el-option label="不限制铸造状态" value=""></el-option>
                        <el-option label="仅看铸造中的" :value="1"></el-option>
                        <el-option label="仅看已铸造的 " :value="2"></el-option>
                        <el-option label="仅看铸造失败的" :value="4"></el-option>
                        <el-option label="仅看合约未上链的" :value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue1" class="input-with-select" size="small">
                        <el-select v-model="params.searchType1" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户昵称" :value="2"></el-option>
                            <el-option label="用户手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue2" class="input-with-select" size="small">
                        <el-select v-model="params.searchType2" slot="prepend" placeholder="请选择">
                            <el-option label="合约名称" :value="1"></el-option>
                            <el-option label="关联周边" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.serialNo" placeholder="请输入铸造流水号" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.orderSn" placeholder="请输入关联订单号" size="small"></el-input>
                </el-col>
                
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="铸造时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="id" label="NFTID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="铸造状态" min-width="90">
                    <template slot-scope="scope">{{status[scope.row.status]}}</template>
                </el-table-column>
                <el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" label="用户昵称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="telephone" label="用户手机号" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column prop="contractName" label="合约名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.contractId" :href="`/nftManage/contract/edit/${scope.row.contractId}`" type="primary" class="ellipsis">
                            {{scope.row.contractName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="serialNo" label="铸造流水号" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goodsName" label="关联周边" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.goodsId" :href="`/goodsManage/goods/edit/${scope.row.goodsId}`" type="primary" class="ellipsis">
                            {{scope.row.goodsName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="rightsNum" label="权益数"></el-table-column>
                <el-table-column prop="exchangeRightsNum" label="已兑换权益" min-width="90"></el-table-column>
                <el-table-column prop="assetsTime" label="铸造时间" min-width="150">
                </el-table-column>
                <el-table-column prop="orderSn" label="关联订单号" min-width="150" show-overflow-tooltip>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="240">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$refs.rightsView.show(scope.row.rightsList)"
                            >权益</el-button
                        >
                        <template v-if="scope.row.status != 5">
                            <el-button
                                v-if="$utils.have('/nft/presentList')"
                                type="text"
                                size="small"
                                @click="presentList(scope.row)"
                                >转赠记录</el-button
                            >
                            <el-button
                                v-if="$utils.have('/nft/exchangeList')"
                                type="text"
                                size="small"
                                @click="exchangeList(scope.row)"
                                >兑换记录</el-button
                            >
                        </template>
                        <el-button
                            v-if="$utils.have('/nft/createNft') && scope.row.status == 4"
                            type="text"
                            size="small"
                            @click="createNft(scope.row)"
                            >重新铸造</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <rights-view ref="rightsView"></rights-view>
    </div>
</template>
<script>
import RightsView from "./components/RightsView.vue";
const defaultParams = {
    pageNo: 1,
    endTime:"",//	铸造结束时间
    id:"",//	nftId
    orderSn:"",//	关联订单号
    searchType1:1,//	搜索条件type1 1：用户ID 2：用户昵称 3：用户手机号	
    searchType2:1,//	搜索条件type2 1：合约名称 2：关联周边	
    searchValue1:"",//	搜索值1
    searchValue2:"",//	搜索值2
    serialNo:"",//	流水号
    startTime:"",//	铸造开始时间
    status:"",//	铸造状态 不限制传空 0：待铸造 1：铸造中 2：铸造成功
    timeType: 1
}
export default {
    components:{RightsView},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                startTime: this.$route.query.startTime || '',
                endTime: this.$route.query.endTime || '',
                timeType: parseInt(this.$route.query.timeType || 1),
                id: this.$route.query.id || '',
                orderSn: this.$route.query.orderSn || '',
                searchType1: parseInt(this.$route.query.searchType1 || 1),
                searchValue1: this.$route.query.searchValue1 || '',
                searchType2: parseInt(this.$route.query.searchType2 || 1),
                searchValue2: this.$route.query.searchValue2 || '',
                serialNo: this.$route.query.serialNo || '',
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
        }
    },
    computed:{
        status(){
            return{
                0:'待铸造', 1:'铸造中', 2:'铸造成功', 3:'转赠中', 4:'铸造失败', 5:'合约未上链'
            }
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.params = {
                ...this.params,
                startTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || ''
            }
            this.listLoading = true;
            this.$request({
                url: "/nft/pageList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },

        //转赠记录跳转
        presentList(data){
            this.$router.push({
                path: `/nftManage/present/list`,
                query: {
                    // searchType: 4,
                    // searchValue: data.userId,
                    // contractName: data.contractName
                    id: data.id
                },
            });
        },
        //兑换记录跳转
        exchangeList(data){
            this.$router.push({
                path: `/nftManage/exchange/list`,
                query: {
                    // searchType: 1,
                    // searchValue: data.userId,
                    // contractName: data.contractName
                    id: data.id
                },
            });
        },
        //铸造
        createNft(item){
            const confirmMsg = `确定要重新铸造吗？`
            this.$confirm(confirmMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.$request({
                    url: "/nft/createNft",
                    method: "POST",
                    params: {
                        nftId: item.id,
                    },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
            }).catch(() => {});
        }
    }
}
</script>
<style lang="scss" scoped>

</style>